import React, { Component } from 'react';

class ShowingResults extends Component {
    render() {
        return (
            <div>
                <p>Showing {this.props.currentEntryStart} to {this.props.currentEntryEnd} of {this.props.totalEntries} entries.{this.props.filterMessage?`(filtered from ${this.props.totalFilterEntries} total entries)`:""} </p>
            </div>
        );
    }
}

export default ShowingResults;